// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


const settings = require('./environment._pipeline_.json');
/*const IntroJs = require('intro.js'); IntroJs: IntroJs,*/

// Adding values to sessionStorage for use in external data logging function
window.sessionStorage.setItem('environmentProperties', JSON.stringify(settings));

export const environment = {
  production: settings.production,
  supportsNonSsoLogin: settings.supportsNonSsoLogin,
  isClassicVDP: settings.isClassicVDP,
  utilPath: {
    asset: settings.utilPath.asset,
    imagesCdn: settings.utilPath.imagesCdn,
    webApi: settings.utilPath.webApi
  },
  domains: {
    adesaCa: settings.domains.adesaCa,
    adesaCom: settings.domains.adesaCom
  },
  interfacePath: {
    buyerOa: settings.interfacePath.buyerOa,
    seller: settings.interfacePath.seller,
    logout: settings.interfacePath.logout,
    auctionLocator: settings.interfacePath.auctionLocator,
    auctionLocatorLink: settings.interfacePath.auctionLocatorLink,
    helpResources: settings.interfacePath.helpResources,
    helpResourcesCaEn: settings.interfacePath.helpResourcesCaEn,
    helpResourcesCaFr: settings.interfacePath.helpResourcesCaFr,
    legal: settings.interfacePath.legal,
    legalCaEn: settings.interfacePath.legalCaEn,
    legalCaFr: settings.interfacePath.legalCaFr,
    privacyPolicy: settings.interfacePath.privacyPolicy,
    privacyPolicyCaEn: settings.interfacePath.privacyPolicyCaEn,
    privacyPolicyCaFr: settings.interfacePath.privacyPolicyCaFr,
    appstoreUS: settings.interfacePath.appstoreUS,
    appstoreCa: settings.interfacePath.appstoreCa,
    appstoreCaFr: settings.interfacePath.appstoreCaFr,
    googleplay: settings.interfacePath.googleplay,
    googlePlayFr: settings.interfacePath.googlePlayFr,
    appStoreAutobid: settings.interfacePath.appStoreAutobid,
    googlePlayAutobid: settings.interfacePath.googlePlayAutobid,
    chatUS: settings.interfacePath.chatUS,
    chatCA: settings.interfacePath.chatCA,
    surveymonkey: settings.interfacePath.surveymonkey,
    surveymonkeyVdp: settings.interfacePath.surveymonkeyVdp,
    surveymonkeyAdvSearch: settings.interfacePath.surveymonkeyAdvSearch,
    surveymonkeySRPSearch: settings.interfacePath.surveymonkeySRPSearch,
    surveymonkeyRecommendations: settings.interfacePath.surveymonkeyRecommendations
  },
  sso: {
    userContext: settings.sso.userContext,
    loginContext: settings.sso.loginContext,
    tokenContext: settings.sso.tokenContext,
    ssoUrl: settings.sso.ssoUrl,
    adesaRewards: settings.sso.adesaRewards,
    currentOrgId: settings.sso.currentOrgId
  },
  watchlist: {
    showRecommendation: settings.watchlist.showRecommendation,
  },
  search: {
    service: settings.search.service,
    isProd: settings.search.isProd,
    auctionDateApi: settings.search.auctionDateApi
  },
  recommendations: {
    isProd: settings.recommendations.isProd,
    api: settings.recommendations.api,
    apiKey: settings.recommendations.apiKey,
    demoMode: settings.recommendations.demoMode
  },
  imola: {
    encryptVin: settings.imola.encryptVin,
    acceptOffer: settings.imola.acceptOffer,
    declineOffer: settings.imola.declineOffer,
    vehicleHistory: settings.imola.vehicleHistory,
    addVehicleToWL: settings.imola.addVehicleToWL,
    removeVehicleFromWL: settings.imola.removeVehicleFromWL,
    vehicleExceptionReport: settings.imola.vehicleExceptionReport,
    emailVehicleRetailView: settings.imola.emailVehicleRetailView,
    userPreferencesFlag: settings.imola.userPreferencesFlag,
    optionalServices: settings.imola.optionalServices,
    blackBookFlag: settings.imola.blackBookFlag
  },
  searchBetaUrl: settings.searchBetaUrl,
  recommedationsBetaUrl: settings.recommedationsBetaUrl,
  hideOldSearchBar: settings.hideOldSearchBar,
  stockWaveAppFlag: {
    set_document_domain_to: settings.stockWaveAppFlag.set_document_domain_to
  },
  logging: {
    dataInspector: settings.logging.dataInspector,
    dwh: settings.logging.dwh
  },
  env: settings.env,
  ifTransferAdesaToMfeEnabled: {
      vdp :               settings.ifTransferAdesaToMfeEnabled ? settings.ifTransferAdesaToMfeEnabled.vdp : undefined,
      watchlist :         settings.ifTransferAdesaToMfeEnabled ? settings.ifTransferAdesaToMfeEnabled.watchlist : undefined,
      recommendations :   settings.ifTransferAdesaToMfeEnabled ? settings.ifTransferAdesaToMfeEnabled.recommendations : undefined,
      search :            settings.ifTransferAdesaToMfeEnabled ? settings.ifTransferAdesaToMfeEnabled.search : undefined
  },
  versions: [
    {
      'module': 'ui-core-shared',
      'version': require('../../../../node_modules/@nw/ui-core-shared/package.json').version
    },
    {
      'module': 'ui-core-assets',
      'version': require('../../../../node_modules/@nw/ui-core-assets/package.json').version
    },
    {
      'module': 'dealerblock-bid-ui',
      'version': require('../../../../node_modules/@nw/dealerblock-bid-ui/package.json').version
    },
    {
      'module': 'ui-search',
      'version': require('../../../../node_modules/@nw/ui-search/package.json').version
    },
    {
      'module': 'ui-watchlist',
      'version': require('../../../../node_modules/@nw/ui-watchlist/package.json').version
    },
    {
      'module': 'ui-recommendations',
      'version': require('../../../../node_modules/@nw/ui-recommendations/package.json').version
    },
    {
      'module': 'ui-vdp',
      'version': require('../../../../node_modules/@nw/ui-vdp/package.json').version
    }
  ]
};



// WEBPACK FOOTER //
// ./src/main/angular/environments/environment.ts